import { applyWhiteLabelThemeToDocument, createWhiteLabelTheme } from "../shared/theme";

export const whiteLabelTheme = createWhiteLabelTheme({
  font: {
    sans: '"Inter", system-ui, sans-serif',
  },
  componentClasses: {
    button: {
      base: "",
      solid: "",
      solidBgColor: "",
      solidTextColor: "",
      outline: "",
      outlineBorderColor: "",
      outlineTextColor: "",
    },
    card: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      mutedBgColor: "",
      softBgColor: "",
      titleColor: "",
      subtitleColor: "",
    },
    dashboardCard: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      mutedTextColor: "",
      accentBgColor: "",
      accentTextColor: "",
    },
    input: {
      base: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      placeholderColor: "",
      labelColor: "",
      focusBorderColor: "",
      focusRingColor: "",
      errorBorderColor: "",
      errorTextColor: "",
    },
    select: {
      trigger: "",
      bgColor: "",
      borderColor: "",
      textColor: "",
      placeholderColor: "",
      menu: "",
      option: "",
      optionHoverBgColor: "",
    },
    header: {
      root: "",
      bgColor: "",
      textColor: "",
      brandTextColor: "",
      phoneTextColor: "",
      menuIconColor: "",
      loginButton: "",
      loginButtonBgColor: "",
      loginButtonTextColor: "",
    },
    sidebar: {
      root: "",
      bgColor: "",
      textColor: "",
      brandTextColor: "",
      activeItem: "",
      activeItemBgColor: "",
      activeItemTextColor: "",
      inactiveItem: "",
      inactiveItemTextColor: "",
      toggleButton: "",
      toggleButtonBgColor: "",
      toggleIconColor: "",
    },
    progressIndicator: {
      wrapperClassName: "bg-gradientbar",
      labelClassName: "",
    },
  },
  colors: {
    canvas: "#F0F9FF",
    canvasMuted: "#E0F2FE",
    surface: "#FFFFFF",
    surfaceSubtle: "#F8FBFF",
    surfaceMuted: "#EFF6FF",
    surfaceSoft: "#DBEAFE",

    primary: "#0284C7",
    primaryAlt: "#0EA5E9",
    primaryHover: "#0369A1",
    primarySoft: "#E0F2FE",

    accent: "#38BDF8",
    accentHover: "#0EA5E9",
    accentStrong: "#0284C7",
    accentSoft: "#E0F2FE",

    text: "#0F172A",
    textMuted: "#475569",
    textSoft: "#64748B",
    textPlaceholder: "#94A3B8",
    textInverse: "#FFFFFF",

    border: "#E2E8F0",
    borderStrong: "#CBD5F5",
    borderLight: "#F1F5F9",

    overlay: "rgba(0, 0, 0, 0.5)",

    success: "#16A34A",
    successSoft: "#ECFDF5",
    successSoftAlt: "#ECFDF5",
    successPale: "#F0FDF4",
    successBright: "#22C55E",
    successHero: "#4ADE80",
    successStrong: "#15803D",
    successDeep: "#166534",
    successBorderSoft: "#BBF7D0",
    successBrightSoft: "#DCFCE7",
    successTextStrong: "#15803D",

    warning: "#F59E0B",
    warningSoft: "#FFFBEB",
    warningBright: "#FACC15",
    warningPale: "#FEFCE8",
    warningBrightSoft: "#FEF9C3",
    warningTextStrong: "#CA8A04",
    warningAlt: "#FB923C",
    warningHero: "#FDE68A",

    danger: "#DC2626",
    dangerSoft: "#FEF2F2",
    dangerBright: "#EF4444",
    dangerHero: "#F87171",
    dangerBrightSoft: "#FEE2E2",
    dangerTextStrong: "#B91C1C",

    info: "#0284C7",
    infoSoft: "#EFF6FF",
    infoBright: "#38BDF8",
    infoSoftAlt: "#DBEAFE",
    infoTextStrong: "#0284C7",
    infoAccent: "#0EA5E9",

    purpleSoft: "#F3E8FF",
    purplePale: "#FAF5FF",
    purpleStrong: "#9333EA",
    purpleText: "#A855F7",

    orangeSoft: "#FFF7ED",
    orangeText: "#EA580C",

    shadow: "rgba(2, 132, 199, 0.08)",
  },
  gradients: {
    primary: {
      start: "#38BDF8",
      end: "#0284C7",
    },
    accent: {
      start: "#7DD3FC",
      end: "#0EA5E9",
    },
    step: {
      start: "#38BDF8",
      end: "#0284C7",
    },
  },
});

export function applyWhiteLabelTheme() {
  applyWhiteLabelThemeToDocument(whiteLabelTheme);
}
